export const diseases_bwccore_eng = [
  {
    label: 'Asthma',
    label_show: 'Asthma',
    page: 6,
    Xpos_image: '220px',
    Ypos_image: '460px',
    Xlabel: '235px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 100, image: 'asthma_2' }
    ]
  },
  {
    label: 'Constipation',
    label_show: 'Constipation',
    page: 6,
    Xpos_image: '330px',
    Ypos_image: '460px',
    Xlabel: '333px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'constipation_0' },
      { min: 4, max: 6, image: 'constipation_1' },
      { min: 7, max: 100, image: 'constipation_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'Food Allergy',
      page: 6,
      Xpos_image: '440px',
      Ypos_image: '460px',
      Xlabel: '445px',
      Ylabel: '550px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 100, image: 'foodallergy_2' }
      ]
  },
  {
    label: 'Immunity',
    label_show: ['Immunity', 'Dysfunction'],
    page: 6,
    Xpos_image: '272px',
    Ypos_image: '585px',
    Xlabel: '277px',
    Ylabel: '675px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'immunedisorder_0' },
      { min: 4, max: 6, image: 'immunedisorder_1' },
      { min: 7, max: 100, image: 'immunedisorder_2' }
    ]
  },
  {
    label: 'Inflammation',
    label_show: ['Intestinal', 'Inflammation'],
    page: 6,
    Xpos_image: '383px',
    Ypos_image: '585px',
    Xlabel: '383px',
    Ylabel: '675px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'Inflammation_0' },
      { min: 4, max: 6, image: 'Inflammation_1' },
      { min: 7, max: 100, image: 'Inflammation_2' }
    ]
  }
]

export const diseases_bwccore_thai = [
  {
    label: 'Asthma',
    label_show: 'หอบหืด',
    page: 5,
    Xpos_image: '220px',
    Ypos_image: '460px',
    Xlabel: '240px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 100, image: 'asthma_2' }
    ]
  },
  {
    label: 'Constipation',
    label_show: 'ท้องผูก',
    page: 5,
    Xpos_image: '330px',
    Ypos_image: '460px',
    Xlabel: '350px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'constipation_0' },
      { min: 4, max: 6, image: 'constipation_1' },
      { min: 7, max: 100, image: 'constipation_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'ภูมิแพ้อาหาร',
      page: 5,
      Xpos_image: '440px',
      Ypos_image: '460px',
      Xlabel: '445px',
      Ylabel: '550px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 100, image: 'foodallergy_2' }
      ]
  },
  {
    label: 'Immunity',
    label_show: 'ภูมิคุ้มกันบกพร่อง',
    page: 5,
    Xpos_image: '272px',
    Ypos_image: '585px',
    Xlabel: '264px',
    Ylabel: '675px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'immunedisorder_0' },
      { min: 4, max: 6, image: 'immunedisorder_1' },
      { min: 7, max: 100, image: 'immunedisorder_2' }
    ]
  },
  {
    label: 'Inflammation',
    label_show: 'ลำไส้อักเสบ',
    page: 5,
    Xpos_image: '383px',
    Ypos_image: '585px',
    Xlabel: '391px',
    Ylabel: '675px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'Inflammation_0' },
      { min: 4, max: 6, image: 'Inflammation_1' },
      { min: 7, max: 100, image: 'Inflammation_2' }
    ]
  }
]

export const diseases_image_bwccore_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_bwccore_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];